module.exports = __webpack_public_path__ + "@/assets/img/arrow-right.f39ce10d.svg";